import "./table_satisfaction.component.style.scss";
import { FC, useContext, useState } from "react";
import TableSatisfactionComponentProps from "./table_satisfaction.component.props";
import ButtonComponent from "../../../../components/button/button.component";
import KeyWordLocalization from "../../../../utils/KeyWordLocalization";
import LocalizationContext from "../../../../providers/localization/LocalizationContext";
import LocalizationContextType from "../../../../../domain/providers/localization/LocalizationContextType";
import { Link } from "react-router-dom";
import routes from "../../../../routes/Routes";
import Testing from "../../../../utils/Testing";
// import { style } from "@angular/animations";

type Props = {
  sortField?: "average_score" | "total_calls_evaluated" | "name";
  sortOrder?: "ASC" | "DESC";
  handleChangeSort?: (field: "average_score" | "total_calls_evaluated" | "name") => void;
};


const TableSatisfactionComponent: FC<TableSatisfactionComponentProps> = ({
  colors,
  data,
  title,
  sortField,
  sortOrder,
  handleChangeSort,
  openAgentDetails,
  showHeader = true,
  downladAgentResume,
}) => {
  const handleClickDetails = async (clientId: string, clientName: string) =>
    openAgentDetails?.(clientId, clientName);
  const handleClickDownload = async (clientId: string) =>
    downladAgentResume?.(clientId);
  const { i18n } = useContext(LocalizationContext) as LocalizationContextType;

  const renderSortableHeader = (
    label: string,
    field: "average_score" | "total_calls_evaluated" | "name"
  ) => {
    const isActive = sortField === field;
    const icon = isActive
      ? sortOrder === "ASC"
        ? "arrow_upward"
        : "arrow_downward"
      : "unfold_more";
  
    return (
      <div
        onClick={() => handleChangeSort?.(field)}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <span>{label}</span>
        <span className="material-symbols-outlined">{icon}</span>
      </div>
    );
  };
  
  return (
        <div className="table_satisfaction_component">
          {showHeader && (
            <div className="w-100 d-flex">
              <div className="flex-grow-1 text_ellipsis">
                <h5>{title}</h5>
              </div>
              <Link to={routes.ranking_human_agents.relativePathWithParams()}>
                {i18n(KeyWordLocalization.TableSatisfactionComponentSeeAll)}
              </Link>
            </div>
          )}
          <div className="w-100 overflow-x-auto">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>
                    {i18n(KeyWordLocalization.TableSatisfactionComponentTitlRankingPosition)}
                  </th>
                  <th>
                    {renderSortableHeader(
                      i18n(KeyWordLocalization.TableSatisfactionComponentTitleName),
                      "name"
                    )}
                  </th>
                  <th>
                    {renderSortableHeader(
                      i18n(KeyWordLocalization.TableSatisfactionComponentTitleScore),
                      "average_score"
                    )}
                  </th>
                  <th>
                    {i18n(KeyWordLocalization.TableSatisfactionComponentTitleSentiments)}
                  </th>
                  <th>
                    {renderSortableHeader(
                      i18n(KeyWordLocalization.TableSatisfactionComponentTotalEvaluatedCalls),
                      "total_calls_evaluated"
                    )}
                  </th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {data.map((client, index) => (
                  <tr key={index}>
                    <td>
                      <div className="py-2">{client.rankingPosition}</div>
                    </td>
                    <td>
                      <div className="py-2">{client.name}</div>
                    </td>
                    <td>
                      {" "}
                      <div className="py-2">{client.score?.toFixed(2)}</div>
                    </td>
                    <td>
                      <div className="d-flex">
                        <div
                          className="mr-2 sentiment_conent"
                          style={{ background: "#0A0A0A" }}
                        >
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#FC776D" }}
                          >
                            sentiment_dissatisfied
                          </span>
                          <span>{client.sentiments.negative}</span>
                        </div>
                        <div
                          className="mr-2 sentiment_conent"
                          style={{ background: "#0A0A0A" }}
                        >
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#FFCE1F" }}
                          >
                            sentiment_neutral
                          </span>
                          <span>{client.sentiments.neutral}</span>
                        </div>
                        <div
                          className="mr-2 sentiment_conent"
                          style={{ background: "#0A0A0A" }}
                        >
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#7EBF42" }}
                          >
                            sentiment_satisfied
                          </span>
                          <span>{client.sentiments.positive}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      {" "}
                      <div className="py-2">{client.totalEvaluatedCalls}</div>
                    </td>
                    <td>
                      <div className="d-flex">
                        <ButtonComponent
                          design="primaryOutline"
                          className="me-2"
                          onClick={() => handleClickDetails(client.id, client.name)}
                          icon={
                            <span className="material-symbols-outlined">
                              visibility
                            </span>
                          }
                        />
                        {downladAgentResume && (
                          <ButtonComponent
                            onClick={() => handleClickDownload(client.id)}
                            style={{ background: "#0A0A0A" }}
                            icon={
                              <span
                                className="material-symbols-outlined"
                                style={{ color: "white" }}
                              >
                                download
                              </span>
                            }
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        );
};

        export default TableSatisfactionComponent;
